




import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { addItemToLocalStorage, getItemFromLocalStorage, StoregeKey } from '../utils';
const scope = 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile openid';
const clientId = '997804807343-qu9shngm5dif8beu7ekouk4s5if7ffur.apps.googleusercontent.com';
@Component({
    components: {}
})
export default class LoginGoogle extends Vue {
    mounted() {
        this.checkIfUserWasAuthenticated();
    }

    forceUserLogin(){
        let self = this;
        google.accounts.id.initialize({
            client_id: clientId,
            context: 'signin',
            auto_select: false,
            callback: self.handleCredentialResponse
        });
        self.prompWasNotShown();
    }

    checkIfUserWasAuthenticated(){
        // let previousCredentials = getItemFromLocalStorage(StoregeKey.GOOGLE_REPORTS_USER_CREDENTIALS);
        // if(previousCredentials !== null)    {
            this.successLogin();
        // }else{
        //     this.forceUserLogin();
        // }
    }

    handleCredentialResponse(response) {
        let credential = response.credential;
        let clientId = response.client_id;
        addItemToLocalStorage(StoregeKey.GOOGLE_REPORTS_USER_CREDENTIALS, credential)
        this.successLogin();
    }

    onSuccess(googleUser) {
        // console.log('Logged in as: ' + googleUser.getBasicProfile().getName());
    }

    onFailure(error) {
        // console.log(error);
    }

    showPrompt() {
        let self = this;
        google.accounts.id.prompt();
    }

    forceSignIn() {}

    @Emit()
    successLogin() {}

    @Emit()
    prompWasNotShown() {}
}
